module.exports = __webpack_public_path__ + "99e8deb2e1e352b4e74f3a7f4aa1a27e.svg";